import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/alerts/visual')({
  beforeLoad: () => getTitleContextSlice('Visual Explorer'),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
